import React, { Component } from "react";
import { BrowserRouter, Route, Redirect } from "react-router-dom";
import sessionStorage from "sessionstorage";

import helpers from "./utils/helpers";
import Header from "./components/Header";
import Form from "./components/Form";

export default class App extends Component {
  state = {
    questions: {
      purpose: "",
      platforms: [],
      project_stage: "",
      budget: null,
      name: "",
      email_address: "",
      phone: "",
    },
    successfulSubmit: false,
  };

  onSubmit = (captchaResponse) => {
    const allData = Object.assign({}, this.state.questions, {
      "g-captcha-response": captchaResponse,
    });
    helpers.createIdea(allData).then((url) => {
      if (url) {
        this.setState({ successfulSubmit: true });
      }
    });
  };

  render() {
    return (
      <div>
        <BrowserRouter>
          <div>
            <Route
              exact
              path="/refinement/"
              render={(routeProps) => (
                <>
                  {this.state.successfulSubmit ? (
                    <div className="push-1x5--top push--bottom">
                      <Header title="Thank you for submitting" subtitle="We look forward to talking more with you!" />
                    </div>
                  ) : (
                    <>
                      <div className="push-1x5--top push--bottom">
                        <Header
                          title="App Refinement Tool"
                          subtitle="What type of project do you need? Get started by fleshing out your idea. Help us help you create something great."
                        />
                      </div>
                      <Form
                        {...routeProps}
                        questions={this.state.questions}
                        setQuestions={(q) => this.setState({ questions: q })}
                        onSubmit={this.onSubmit}
                      />
                    </>
                  )}
                </>
              )}
            />
          </div>
        </BrowserRouter>
      </div>
    );
  }
}
